/**
 * Utilities for reading theme colors from CSS custom properties.
 *
 * Canvas-based visuals (the Three.js particle network and the chart
 * canvases) can't consume `var()` directly, so they read the computed
 * values here and refresh themselves when ThemeProvider dispatches
 * the `themechange` event.
 */

export function cssVar(name, fallback = '') {
    if (typeof window === 'undefined') return fallback;
    const value = window.getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    return value || fallback;
}

export function currentTheme() {
    if (typeof document === 'undefined') return 'light';
    return document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
}

/** Subscribe to theme changes; returns an unsubscribe function. */
export function onThemeChange(callback) {
    document.addEventListener('themechange', callback);
    return () => document.removeEventListener('themechange', callback);
}

/** Palette for the Three.js particle network (hex colors). */
export function getFxPalette() {
    return {
        particle: cssVar('--fx-particle', '#00f0ff'),
        particleAlt: cssVar('--fx-particle-alt', '#7c3aed'),
    };
}

/** Palette for canvas-drawn charts (RGB channel strings, for rgba() use). */
export function getPlotPalette() {
    return {
        bg: cssVar('--plot-bg', '#111627'),
        axis: cssVar('--plot-axis-rgb', '147, 153, 178'),
        s1: cssVar('--plot-series-1-rgb', '99, 102, 241'),
        s2: cssVar('--plot-series-2-rgb', '34, 211, 238'),
        s3: cssVar('--plot-series-3-rgb', '244, 67, 54'),
        good: cssVar('--plot-good-rgb', '16, 185, 129'),
        cellText: cssVar('--plot-cell-text-rgb', '255, 255, 255'),
    };
}
